import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Category, SubCategory } from '@chemist2u/types-client/C2U/ParseObjects';
import { ImageComponent } from '../../primitives/image/image.component';

@Component({
    selector: 'app-category-button-small',
    templateUrl: './category-button-small.component.html',
    styleUrls: ['./category-button-small.component.scss'],
    imports: [ImageComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryButtonSmallComponent {
  public data = input.required<Category | SubCategory>();
  public type = input<'category' | 'subcategory'>('category');

  public name = computed (() => this.data().name || '');
  public imageThumb = computed(() => this.data().imageThumb?._url);
}